export const allowedRoles = ['etudiant', 'enseignant', 'technicien'];
export function isAllowedUser(user) { return allowedRoles.includes(user?.role); }
export function loginDestination(user) {
    const shared = new URLSearchParams(window.location.search).get('application');
    if (user.role === 'etudiant' && /^\d+$/.test(shared || '')) return `/etudiant/telecharger-applications?app=${shared}`;
    return { etudiant: '/etudiant', enseignant: '/enseignant', technicien: '/technicien' }[user.role] || '/login';
}
